module.exports = __webpack_public_path__ + "img/net-sentiment.cb152a20.png";